<p-dialog
  [visible]="transferProspectModal()"
  [resizable]="false"
  appendTo="body"
  [modal]="true"
  [closeOnEscape]="true"
  (onHide)="closeDialogEvent()"
  [breakpoints]="{ '767px': '100vw' }"
  [style]="{ width: '660px' }"
  styleClass="no-header-modal overflow-visible"
>
  <ng-template pTemplate="header" styleClass="hidden" />
  <ng-template pTemplate="content" styleClass="p-0">
    @if (
      {
        client: allClientData$ | async,
        currentTenant: currentTenant$ | async,
        allTenants: allTenants$ | async,
        selectedTenant: selectedTenant$ | async,
      };
      as $
    ) {
      <!-- Header -->
      <div
        class="p-3 flex align-items-center justify-content-between border-bottom-1 border-300"
      >
        <div class="flex align-items-center">
          <h2 class="mb-0 text-sm">
            {{ 'TRANSFER_PROSPECT.TRANSFER_PROSPECT_TITLE' | translate }}
            <strong>{{ $.client.full_name }}</strong>
            <span class="text-xs text-600"> - {{ $.client.id }}</span>
          </h2>
        </div>
        <div
          class="fa fa-times text-xl text-600 cursor-pointer"
          (click)="closeDialogEvent()"
        ></div>
      </div>
      <!-- Header -->
      <form
        [formGroup]="transferProspectFormGroup"
        (ngSubmit)="transferProspect()"
      >
        <!-- Modal Content -->
        <div class="surface-100 border-bottom-1 border-300 p-3 md:px-5">
          <!-- Column -->
          <div class="mb-4">
            <label class="font-medium text-700 text-xs mb-2 block uppercase">{{
              'TRANSFER_PROSPECT.CURRENT_TENANT' | translate
            }}</label>
            <div class="flex align-items-center">
              <span class="text-sm">{{
                $.currentTenant.name_primary_language ||
                  $.currentTenant.name_secondary_language
              }}</span>
            </div>
          </div>
          <!-- Column -->
          <!-- Column -->
          <div class="mb-2">
            <label class="font-medium text-700 text-xs mb-2 block uppercase">{{
              'TRANSFER_PROSPECT.NEW_TENANT' | translate
            }}</label>
            <!-- <div class="relative"> -->
            <multi-tenant-list
              (emittedTenant)="selectTenant($event)"
              [class]="'p-treeselect-label'"
              [styleClass]="'w-full h-full'"
              [showInActiveTenant]="false"
            />
            @if (NewTenant.dirty && NewTenant.invalid) {
              <app-error-msg
                [errors]="NewTenant.errors"
                [fieldLabel]="'TRANSFER_PROSPECT.NEW_TENANT' | translate"
              />
            }
            <!-- </div> -->
          </div>
          <!-- Column -->
          <!-- Column -->
          <div class="mb-2">
            <label class="font-medium text-700 text-xs mb-2 block uppercase">{{
              'TRANSFER_PROSPECT.CLIENT_REP' | translate
            }}</label>
            <!-- <div class="relative"> -->
            <staff-selector
              [formGroup]="transferProspectFormGroup"
              [controlName]="NewClientRep"
              [filterstaff]="staffIds$"
              [claims]="claims"
              [styleClass]="'w-full text-sm py-0 align-items-center'"
            />
            @if (NewClientRep.dirty && NewClientRep.invalid) {
              <app-error-msg
                [errors]="NewClientRep.errors"
                [fieldLabel]="'TRANSFER_PROSPECT.CLIENT_REP' | translate"
              />
            }
            <!-- </div> -->
          </div>
          <!-- Column -->
        </div>
        <!-- Modal Content -->
        <!-- Modal Footer -->
        <div
          class="flex align-items-center justify-content-between border-top-1 border-300 p-3"
        >
          <div class="w-4">
            <p-button
              type="button"
              [label]="'SALE_REPRESENTATIVE.CANCEL' | translate"
              styleClass="p-button-link p-0 text-sm"
              (click)="closeDialogEvent()"
            />
          </div>
          <div class="w-8 text-right">
            <p-button
              type="submit"
              styleClass="text-sm"
              [disabled]="!transferProspectFormGroup.valid"
              [label]="'TRANSFER_PROSPECT.TRANSFER_PROSPECT' | translate"
              [loading]="isloading"
            />
          </div>
        </div>
        <!--Modal Footer -->
      </form>
    }
  </ng-template>
</p-dialog>
